<template>
  <div class="main-data" v-loading="loading || fileUploading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="dynamicRules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Viloyat">
                <el-select
                    style="width: 100%"
                    size="large"
                    v-model="selectedRegion"
                    :disabled="$route.params.id && $store.state.role !== 'admin'"
                    @change="getDistricts"
                    :loading="regionsLoading"
                    placeholder="Malumot kiriting"
                >
                  <el-option
                      v-for="region in regions"
                      :key="region.id"
                      :value="region.id"
                      :label="region.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tuman" prop="district_id">
                <el-select
                    style="width: 100%"
                    size="large"
                    :disabled="$route.params.id && $store.state.role !== 'admin'"
                    v-model="form.district_id"
                    :loading="districtsLoading"
                    placeholder="Malumot kiriting"
                >
                  <el-option
                      v-for="district in districts"
                      :key="district.id"
                      :value="district.id"
                      :label="district.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Mahalla nomi" prop="title">
                <el-input
                    size="large"
                    :disabled="$route.params.id && $store.state.role !== 'admin'"
                    class="form-input"
                    placeholder="Malumot kiriting"
                    v-model="form.title"
                    type="text"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Aholi soni" prop="citizen_count">
                <el-input
                    :disabled="$route.params.id && $store.state.role !== 'admin'"
                    size="large"
                    class="form-input"
                    placeholder="Malumot kiriting"
                    v-model.number="form.citizen_count"
                    type="number"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Soliq nomi va kodi" prop="id_number_id">
                <el-select
                    style="width: 100%"
                    size="large"
                    clearable
                    v-model="form.id_number_id"
                    filterable
                    placeholder="Malumot kiriting"
                >
                  <el-option
                      v-for="opt in id_numbers"
                      :key="opt.id"
                      :value="opt.id"
                      :label="opt.title + ' - ' + opt.id_number"
                      :class="{ is_available: !opt.is_available }"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Hisob raqami" prop="account_number_id">
                <el-select
                    style="width: 100%"
                    size="large"
                    clearable
                    placeholder="Malumot kiriting"
                    filterable
                    v-model="form.account_number_id"
                >
                  <el-option
                      v-for="account in account_numbers"
                      :key="account.id"
                      :value="account.id"
                      :label="account.acc_number"
                      :class="{ is_available: !account.is_available }"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Status" prop="status">
                <el-select
                    style="width: 100%"
                    size="large"
                    placeholder="Malumot kiriting"
                    filterable
                    v-model="form.status"
                    :disabled="$route.params.id && $store.state.role !== 'admin'"
                >
                  <el-option
                      v-for="stat in statuses"
                      :key="stat.id"
                      :value="stat.id"
                      :label="stat.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Moliyaviy holati" prop="status">
                <el-select
                    style="width: 100%"
                    size="large"
                    placeholder="Tanlang"
                    filterable
                    v-model="form.financial_status"
                >
                  <el-option
                      v-for="stat in financialStatuses"
                      :key="stat.value"
                      :value="stat.value"
                      :label="stat.label"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
                :xs="24"
                :sm="24"
                :md="12"
                :lg="12"
                :xl="12"
                v-if="form.status === 'ARCHIVE' && $store.state.role === 'admin'"
            >
              <el-form-item
                  label="Qoshimcha mahalla nomi"
                  prop="additional_quarter_id"
              >
                <el-select
                    style="width: 100%"
                    size="large"
                    placeholder="Malumot kiriting"
                    filterable
                    v-model="form.additional_quarter_id"
                    :disabled="$route.params.id && $store.state.role !== 'admin'"
                >
                  <el-option
                      v-for="quarter in additionalQuartersList"
                      :key="quarter.id"
                      :value="quarter.id"
                      :label="quarter.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="file">
                <template #label>
                  <span>
                    Fayl (PDF)
                    <span v-if="isUpdate" class="required-star">*</span>
                  </span>
                </template>
                <el-upload
                  ref="upload"
                  class="quarter-file-upload"
                  v-model:file-list="fileList"
                  :on-change="handleFileChange"
                  :on-remove="handleFileRemove"
                  :on-exceed="handleFileExceed"
                  :auto-upload="false"
                  :show-file-list="true"
                  accept=".pdf,application/pdf"
                  :limit="1"
                >
                  <el-button size="small" type="primary">Fayl tanlang</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24" style="margin-top: 8px;">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)">
                  Orqaga
                </el-button>
                <el-button class="custom-btn" type="primary" @click="onSubmit">
                  Saqlash
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div v-if="isUpdate" class="history-actions">
          <el-button
            class="custom-btn"
            plain
            :loading="historyLoading"
            @click="toggleFileHistory"
          >
            O'zgarishlar tarixi
          </el-button>
        </div>
      </el-col>

      <el-col v-if="fileHistoryVisible" :span="24">
        <div class="history-section">
          <el-table
            :data="fileHistory"
            border
            empty-text="Tarix topilmadi"
            style="width: 100%"
          >
            <el-table-column type="index" width="60" />
            <el-table-column label="O'zgartirdi FIO" min-width="230">
              <template #default="scope">
                {{ scope.row.updated_by_fullname || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="O'zgartirdi PINFL" min-width="170">
              <template #default="scope">
                {{ scope.row.updated_by_pinfl || "-" }}
              </template>
            </el-table-column>
            <el-table-column label="O'zgartirdi ID" min-width="280">
              <template #default="scope">
                <button
                  v-if="scope.row.updated_by"
                  type="button"
                  class="history-copy-button"
                  @click="copyHistoryValue(scope.row.updated_by, `O'zgartirdi ID`)"
                >
                  {{ scope.row.updated_by }}
                </button>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="Vaqti" min-width="190">
              <template #default="scope">
                {{
                  scope.row.created_at
                    ? $moment(scope.row.created_at).format("DD.MM.YYYY / HH:mm:ss")
                    : "-"
                }}
              </template>
            </el-table-column>
            <el-table-column label="File yuklash" min-width="140" fixed="right">
              <template #default="scope">
                <a
                  v-if="scope.row.pdf_url"
                  :href="fileBaseUrl + scope.row.pdf_url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="history-download-button"
                >
                  Yuklash
                </a>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";

export default {
  name: "QuarterForm",
  watch: {
    "form.district_id": function () {
      this.getAccounts();
      this.getIDs();
    },
    "form.status": function () {
      if (
          !this.additionalQuartersList.length &&
          this.form.status == "ARCHIVE" &&
          this.$store.state.role == "admin"
      ) {
        this.getQuarterList();
      }

      if (this.form.status == "ACTIVE") {
        this.form.additional_quarter_id = null;
      }
    },
  },
  data() {
    return {
      loading: false,
      fileUploading: false,
      historyLoading: false,
      regionsLoading: false,
      districtsLoading: false,
      statuses: [
        {id: "ARCHIVE", title: "Arxiv"},
        {id: "ACTIVE", title: "Faol"},
      ],
      regions: [],
      districts: [],
      additionalQuartersList: [],
      id_numbers: [],
      account_numbers: [],
      selectedRegion: null,
      fileList: [],
      fileHistoryVisible: false,
      fileHistoryLoaded: false,
      fileHistory: [],
      fileBaseUrl: process.env.VUE_APP_BASE_API_URL + "api/v2/info/file/",
      form: {
        id: null,
        status: null,
        title: null,
        district_id: null,
        citizen_count: null,
        account_number_id: null,
        id_number_id: null,
        additional_quarter_id: null,
        financial_status: 'GOOD',
        file: null,
        pdf_url: null
      },
      financialStatuses: [
        {value: 'GOOD', label: "Yaxshi"},
        {value: 'BAD', label: "Og'ir"}
      ],
    };
  },
  computed: {
    isUpdate() {
      return !!this.$route.params.id;
    },
    dynamicRules() {
      return {
        title: [
          {required: true, message: "Majburiy maydon", trigger: "blur"},
        ],
        district_id: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        citizen_count: [
          {required: true, message: "Majburiy maydon", trigger: "blur"},
        ],
        file: [
          {validator: this.validateFileField, trigger: "change"},
        ],
      };
    }
  },
  methods: {
    isPdfFile(file) {
      if (!file) {
        return false;
      }

      const fileName = String(file.name || "").toLowerCase();

      return file.type === "application/pdf" || fileName.endsWith(".pdf");
    },
    validateFileField(rule, value, callback) {
      if (this.isUpdate && !this.form.file) {
        callback(new Error("PDF fayl yuklash majburiy"));
        return;
      }

      if (this.form.file && !this.isPdfFile(this.form.file)) {
        callback(new Error("Faqat PDF fayl yuklash mumkin"));
        return;
      }

      if (this.fileUploading) {
        callback(new Error("PDF fayl yuklanmoqda, biroz kuting"));
        return;
      }

      if (this.form.file && !this.form.pdf_url) {
        callback(new Error("PDF faylni yuklash yakunlanmagan"));
        return;
      }

      callback();
    },
    resetFileSelection() {
      this.form.file = null;
      this.form.pdf_url = null;
      this.fileList = [];
      this.$refs.upload?.clearFiles();
      this.$nextTick(() => {
        this.$refs.form?.validateField("file", () => {});
      });
    },
    createLocalFileItem(file) {
      return {
        name: file.name,
        percentage: 0,
        raw: file,
        size: file.size,
        status: "success",
        uid: file.uid || Date.now(),
      };
    },
    handleFileExceed(files) {
      const rawFile = files?.[0];

      if (!rawFile) {
        return;
      }

      this.fileList = [];
      this.$refs.upload?.clearFiles();
      this.processSelectedFile(rawFile);
    },
    handleFileRemove() {
      this.form.file = null;
      this.form.pdf_url = null;
      this.fileList = [];
      this.$nextTick(() => {
        this.$refs.form?.validateField("file", () => {});
      });
    },
    uploadPdfFile(file) {
      const formData = new FormData();
      formData.append("file", file);

      this.fileUploading = true;

      return this.$http
          .post("api/v2/info/file/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(({data}) => {
            this.form.pdf_url = data.hashId;
          })
          .catch(({response}) => {
            this.resetFileSelection();
            ElNotification({
              title: "Xatolik",
              message:
                  response?.data?.message || "PDF faylni yuklashda xatolik sodir bo'ldi",
              type: "error",
            });
          })
          .finally(() => {
            this.fileUploading = false;
            this.$nextTick(() => {
              this.$refs.form?.validateField("file", () => {});
            });
          });
    },
    processSelectedFile(rawFile) {
      if (!this.isPdfFile(rawFile)) {
        ElNotification({
          title: "Xatolik",
          message: "Faqat PDF fayllar ruxsat etiladi",
          type: "error",
        });
        this.resetFileSelection();
        return;
      }

      this.form.file = rawFile;
      this.form.pdf_url = null;
      this.fileList = [this.createLocalFileItem(rawFile)];
      this.$refs.form?.clearValidate("file");
      this.uploadPdfFile(rawFile);
    },
    handleFileChange(file) {
      if (!file?.raw) {
        return;
      }

      this.processSelectedFile(file.raw);
    },
    fetchFileHistory() {
      const quarterId = this.$route.params.id || this.form.id;

      if (!quarterId) {
        return Promise.resolve();
      }

      this.historyLoading = true;

      return this.$http
          .get(`/api/v1/quarters/${quarterId}/file-history`)
          .then(({data}) => {
            this.fileHistory = Array.isArray(data) ? data : data?.history || [];
            this.fileHistoryLoaded = true;
            this.fileHistoryVisible = true;
          })
          .catch(({response}) => {
            ElNotification({
              title: "Xatolik",
              message:
                  response?.data?.message || "O'zgarishlar tarixini yuklashda xatolik sodir bo'ldi",
              type: "error",
            });
          })
          .finally(() => {
            this.historyLoading = false;
          });
    },
    toggleFileHistory() {
      if (this.fileHistoryVisible) {
        this.fileHistoryVisible = false;
        return;
      }

      if (this.fileHistoryLoaded) {
        this.fileHistoryVisible = true;
        return;
      }

      this.fetchFileHistory();
    },
    async copyHistoryValue(value, label) {
      const text = String(value || "").trim();

      if (!text) {
        return;
      }

      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          const textArea = document.createElement("textarea");
          textArea.value = text;
          textArea.setAttribute("readonly", "");
          textArea.style.position = "absolute";
          textArea.style.left = "-9999px";
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
        }

        ElNotification({
          title: "Nusxalandi",
          message: `${label} nusxalandi`,
          type: "success",
        });
      } catch (error) {
        ElNotification({
          title: "Xatolik",
          message: `${label} ni nusxalab bo'lmadi`,
          type: "error",
        });
      }
    },
    getPayload() {
      const payload = {};

      Object.keys(this.form).forEach((key) => {
        if (key === "file" || key === "id") {
          return;
        }

        if (this.form[key] !== null) {
          payload[key] = key === "citizen_count" && this.form[key] !== ""
              ? Number(this.form[key])
              : this.form[key];
        }
      });

      return payload;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.fileUploading) {
            ElNotification({
              title: "Ogohlantirish",
              message: "PDF fayl hali yuklanmoqda, biroz kuting",
              type: "warning",
            });
            return;
          }

          this.loading = true;
          const quarterId = this.$route.params.id || this.form.id;
          const payload = this.getPayload();

          let http;

          if (quarterId) {
            http = this.$http.put(`/api/v1/quarters/${quarterId}`, payload);
          } else {
            http = this.$http.post("/api/v1/quarters", payload);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      });
    },
    getIDs() {
      this.districtsLoading = true;
      this.$http
          .get("/api/v1/quarter-id-numbers/select", {
            params: {
              region_id: this.selectedRegion,
              district_id: this.form.district_id,
            },
          })
          .then(({data}) => {
            this.id_numbers = data.result;
          })
          .catch(() => {
          })
          .finally(() => {
            this.districtsLoading = false;
          });
    },
    getAccounts() {
      this.districtsLoading = true;
      this.$http
          .get("/api/v1/quarter-acc-numbers/select", {
            params: {
              region_id: this.selectedRegion,
              district_id: this.form.district_id,
            },
          })
          .then(({data}) => {
            this.account_numbers = data.result;
          })
          .catch(() => {
          })
          .finally(() => {
            this.districtsLoading = false;
          });
    },
    getQuarterList() {
      this.loading = true;
      this.$http
          .get("/api/v1/quarters")
          .then(({data}) => {
            this.additionalQuartersList = data.quarters;
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
          .get("/api/v1/regions")
          .then(({data}) => {
            this.regions = data.regions;
          })
          .catch(() => {
          })
          .finally(() => {
            this.regionsLoading = false;
          });
    },
    getDistricts() {
      this.districtsLoading = true;
      this.$http
          .get("/api/v1/districts", {
            params: {
              region_id: this.selectedRegion,
            },
          })
          .then(({data}) => {
            this.districts = data.districts;
          })
          .catch(() => {
          })
          .finally(() => {
            this.districtsLoading = false;
          });
    },
    getQuarter(id) {
      this.loading = true;
      this.$http
          .get(`/api/v1/quarters/${id}`)
          .then(({data}) => {
            this.form = {
              ...this.form,
              ...data,
              file: null,
              pdf_url: null,
            };
            this.fileList = [];
            this.getDistrict(this.form.district_id);
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getDistrict(id) {
      this.loading = true;
      this.$http
          .get(`/api/v1/districts/${id}`)
          .then(({data}) => {
            this.districts.push(data);
            this.selectedRegion = data.region_id;
            this.getDistricts();
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.getQuarter(this.$route.params.id);
    }

    if (this.$store.state.role !== "admin" && !this.$route.params.id) {
      this.$router.go(-1);
    }

    this.getRegions();
  },
};
</script>

<style scoped>
.is_available {
  display: none;
}

.required-star {
  color: #f56c6c;
}

.quarter-file-upload {
  width: 100%;
}

.quarter-file-upload :deep(.el-upload-list) {
  width: 100%;
  max-width: 170px;
}

.quarter-file-upload :deep(.el-upload-list__item) {
  width: 100%;
}

.quarter-file-upload :deep(.el-upload-list__item-name) {
  max-width: calc(100% - 24px);
}

.history-actions {
  margin-top: 16px;
}

.history-section {
  max-width: 1700px;
  margin-top: 16px;
  border: 1px solid #dcdfe6;
  border-radius: 12px;
  padding: 10px;
  background: #fff;
}

.history-section__title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}

.history-copy-button {
  border: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  color: var(--el-color-primary);
  cursor: pointer;
  text-align: left;
  width: 100%;
}

.history-copy-button:hover {
  text-decoration: underline;
}

.history-download-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 90px;
  padding: 8px 12px;
  border-radius: 6px;
  background: var(--el-color-primary);
  color: #fff;
  text-decoration: none;
}

.history-download-button:hover {
  background: var(--el-color-primary-light-3);
}
</style>
